/** 梦箱（AI 跑团）子站首页，域名与登录接力页共用 NEXT_PUBLIC_DREAMBOX_HOSTS 的第一个 */
export const DREAMBOX_URL = `https://${(process.env.NEXT_PUBLIC_DREAMBOX_HOSTS || 'dream.hiwaifu.com').split(',')[0]!.trim()}/`
